export default __webpack_public_path__ + "static/INRM-Shillong-0a303dc406eaec1112452d21e2f138b7.png";